"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiEntity, StrapiQuery, StrapiQueryValue } from "@/lib/strapi";
import type { ProductAttributes } from "@/services/product";

export type UseTryUsProductsOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  pageSize?: number;
  withBrandFilter?: boolean;
};

export function useTryUsProducts(options?: UseTryUsProductsOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      show_in_try_us: { $eq: true },
      active: { $eq: true },
      product_category: {
        id: { $notNull: true },
      },
    },
    sort: options?.query?.sort ?? ["product_category.name:asc"],
    pagination: {
      ...(typeof options?.query?.pagination === "object" && options?.query?.pagination !== null
        ? (options.query.pagination as Record<string, unknown>)
        : {}),
      pageSize: options?.pageSize ?? 3,
    },
    populate:
      options?.populate !== undefined
        ? options.populate
        : (options?.query?.populate ?? {
            cover_image: { populate: "*" },
            product_banner: { populate: "*" },
            product_category: { populate: "*" },
          }),
  };

  const state = useFetchApi<StrapiCollectionResponse<ProductAttributes>>("/products", {
    enabled: options?.enabled,
    query,
    withBrandFilter: options?.withBrandFilter,
    cacheTtlMs: 3600_000,
  });

  const products: Array<StrapiEntity<ProductAttributes>> = state.data?.data ?? [];

  return { ...state, products };
}

